// src/components/ResizeImage.js
export const resizeImage = (file, maxSize, tip) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                let width = img.width;
                let height = img.height;

                if (tip === 'service') {
                    // Set both width and height to maxSize for service images
                    width = maxSize;
                    height = maxSize;
                } else if (tip === 'profile') {
                    // Adjust based on aspect ratio for profile images
                    if (width > height) {
                        // Landscape orientation
                        if (width > maxSize) {
                            height = (height * maxSize) / width;
                            width = maxSize;
                        }
                    } else {
                        // Portrait orientation
                        if (height > maxSize) {
                            width = (width * maxSize) / height;
                            height = maxSize;
                        }
                    }
                }

                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            resolve(blob);
                        } else {
                            reject(new Error('Image resizing failed.'));
                        }
                    },
                    'image/jpeg',
                    0.8 // Quality
                );
            };
        };
        reader.readAsDataURL(file);
    });
};
